import { useState, useRef } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function AudioPlayer() {
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const togglePlay = () => {
        if (!audioRef.current) return;

        if (isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);
        } else {
            audioRef.current.play().then(() => {
                setIsPlaying(true);
            }).catch((err) => {
                console.log("Erro ao reproduzir áudio:", err);
            });
        }
    };

    return (
        <div className="fixed bottom-6 right-24 z-40">
            <audio ref={audioRef} src="/musica-fundo.mp3" loop prefetch="auto" />
            
            <button
                type="button"
                onClick={togglePlay}
                aria-label={isPlaying ? "Mutar música de fundo" : "Tocar música de fundo"}
                className={`flex h-12 w-12 items-center justify-center rounded-full border transition-all duration-300 ${
                    isPlaying
                        ? "border-gold bg-ink-900 text-gold shadow-[0_0_20px_rgba(197,160,89,0.3)] scale-105"
                        : "border-white/20 bg-ink-900/80 text-slate-400 hover:border-gold/50 hover:text-gold-light backdrop-blur-md"
                }`}
            >
                {isPlaying ? <Volume2 size={18} /> : <VolumeX size={18} />}
            </button>
        </div>
    );
}